import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.id,
    mainReportId: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.id,
    requestParams: {
      originImpc: rowInfo.row['origin.impc'], // eslint-disable-line
      destinationImpc: rowInfo.row['destination.impc'], // eslint-disable-line
      mailCategory: rowInfo.row['despatch.mailCategory'], // eslint-disable-line
      mailClass: rowInfo.original.despatch.mailClassWithSubClass, // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Sender', 'predes.sender'),
        new TextColumn('Receiver', 'predes.receiver'),
        new TextColumn('Sending mailbox', 'predes.sendingMailbox'),
        new TextColumn('Receiving mailbox', 'predes.receivingMailbox'),
      ],
    },
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'origin.operator'),
        new TextColumn('Code', 'origin.impc'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destination.operator'),
        new TextColumn('Code', 'destination.impc'),
      ],
    },
    {
      Header: 'Despatch',
      columns: [
        new TextColumn('Mail category', 'despatch.mailCategory'),
        new TextColumn('Mail class', 'despatch.mailClass').withTotalHeader('Total'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('PREDES', 'receptacles.predes').withTotalHeader(sumTotal), getDetailsTabNavigationProps),
        new NavigationColumn(new NonZeroNumberColumn('PRECON', 'receptacles.precon').withTotalHeader(sumTotal), getDetailsTabNavigationProps),
        new NavigationColumn(new NonZeroNumberColumn('PREDES - PRECON', 'receptacles.diff').withTotalHeader(sumTotal), getDetailsTabNavigationProps),
        new NonZeroPercentageColumn('PRECON / PREDES', 'receptacles.pct').withTotalHeader(totalRowRatio(['receptacles.precon', 'receptacles.predes'])),
      ],
    },
  ];
};
